<h1 class="sd-headline sd-headline--size-base">{{data().text}}</h1>
